module.exports = __webpack_public_path__ + "media/elevadizo/buqueDerecha-dd-a33cafe4.png";